<template>
<div>
    <div id="timer" class="timer"  >
        <div class="text-md-center">
            <span class="ml-1 mt-1 pa-1"  >{{raceTitle}}  <span class="mr-2" style="float:right">Live <strong>{{ raceTime }}</strong></span></span>
        </div>
    </div>

    <div id="menuLaterale" class="menu-container"  v-if="card == ''">
        <span class="tab-menu"  @click="card = 'top10'"  >
            <v-icon small class="green--text pb-2">people</v-icon>
            <span class="ml-4"><strong>LEADERS</strong></span>
        </span>
        <span class="tab-menu text-md-center" @click="card = 'pref'" >
            <v-icon small class="yellow--text pb-2">star_rate</v-icon>
            <span class="ml-2"><strong>PREFERITI</strong></span>
        </span>
        <span class="tab-menu text-md-center"  @click="card = 'staff'">
            <v-icon small class="orange--text pb-2">groups</v-icon>
            <span class="ml-2"><strong>STAFF</strong></span>
        </span>
    </div>

    <div id="card" class="top10-container" style="float: right" v-if="card == 'top10'">
        <div >
            <v-icon small class="green--text mt-1">people</v-icon>
            <v-icon style="float: right" small class="orange--text mt-1 ml-4" @click="card = ''">close</v-icon>
            <span class="ml-1"><strong>LEADERS</strong></span>
        </div>

        <div v-for="(partecipante, index) in top10" :key="partecipante.id + '' + index" class="mt-2" @click="centerTo(partecipante.lonLat)">
            <span style="
                            background-color: orange;
                            color: black;
                            padding: 4px;
                            border-radius: 3px;
                            width: 130px;
                        ">{{ index + 1  }}</span>
            <small class="mr-2 ml-2"><b>{{ getPartecipante(partecipante) }}</b>
            </small> <span style="float: right" class="passo">{{ partecipante.passo }} </span><span style="float: right" class="passo">km. {{ roundKm(deviceMap[partecipante.deviceid].posIndex)     }} </span>

        </div>
    </div>

    <div id="card3" class="staff-container" style="float: right" v-if="card == 'staff'">
        <div >
            <v-icon small class="orange--text mt-1">groups</v-icon>
            <v-icon style="float: right" small class="orange--text mt-1 ml-4" @click="card = ''">close</v-icon>
            <span class="ml-1"><strong>STAFF</strong></span>
        </div>

        <div v-for="(partecipante, index) in staff" :key="partecipante.id + '' + index" class="mt-2" @click="centerTo(partecipante.lonLat)">
            <span :class="'mr-2 pa-1 marker'+partecipante.icon">{{ getStaff(partecipante) }} </span>
            <span style="float: right" >km. {{ roundKm(deviceMap[partecipante.deviceid].posIndex)     }} </span>
        </div>
    </div>

    <div id="card4" class="staff-container" style="float: right" v-if="card == 'pref'">
        <div >
            <v-icon small class="orange--text mt-1">star</v-icon>
            <v-icon style="float: right" small class="orange--text mt-1 ml-4" @click="card = ''">close</v-icon>
            <span class="ml-1"><strong>PREFERITI</strong></span>
        </div>

        <div v-for="(partecipante, index) in preferiti" :key="partecipante.id + '' + index" class="mt-2" @click="centerTo(partecipante.lonLat)">
            <span style="
                            background-color: orange;
                            color: black;
                            padding: 4px;
                            border-radius: 3px;
                            width: 130px;
                        ">{{ index + 1  }}</span>
            <small class="mr-2 ml-2"><b><span :class="'participant'+partecipante.icon">{{ getPartecipante(partecipante) }}</span></b>
            </small> <span style="float: right" class="passo">km. {{ roundKm(deviceMap[partecipante.deviceid].posIndex)     }} </span>

        </div>
    </div>

    <altimetria v-if="showAltimetria" v-bind:class="[toggleClass]" :style="altimetriaStyle()" :data="altitude" :index="index"></altimetria>

    <div id="mapContainer" class="basemap" :style="mapStyle()"></div>

    <div id="footer" class="footer-container">
        <div id="menu">
            <input id="satellite-v9" type="radio" name="rtoggle" value="satellite" />
            <label for="satellite-v9">satellite</label>
            <input id="outdoors-v11" type="radio" name="rtoggle" value="outdoors" />
            <label for="outdoors-v11">outdoors</label>
        </div>
        <!--v-btn small @click="setMapType('street')">Street</v-btn>
            <v-btn small @click="setMapType('satellite')">Satellite</v-btn-->
    </div>
</div>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import * as turf from '@turf/turf';
//import * as d3 from 'd3';
import Altimetria from './Altimetria.vue';
//import Passo from './Passo.vue';

const moment = require('moment');

export default {
    components: {
        Altimetria
    },
    name: 'BaseMap',
    props: {
        idEvento: String,
        bibList: Array,
        moltiplicatore: Number,
        configuration: Array,
        isAddPoi: Boolean,
        listaPoi: Array,
        settings: Object,
        participants: Array,
        deviceMap: Object,
        raceTime: String,
        raceTitle: String,
        listaRil: Array
    },
    data() {
        return {
            accessToken: 'pk.eyJ1IjoidGVtcG9nYXJhIiwiYSI6ImNraXRhaDdhOTBtcHgzMHBkbmhqZG9xemQifQ.Pwne0YUkG5UUZP6I97AMKA',

            markers: {},
            trackdataraw: {},

            maxFrames: 100,
            currentFrame: 0,

            map: null,

            currentPoint: null,

            trax: {},
            heliInizialized: false,
            heliDistance: '',
            heliRunning: false,
            coordinates: [],

            velocita: 1000000,

            pause: false,
            styleMap: 'mapbox://styles/mapbox/satellite-v9',

            toggleClass: 'ani1',
            index: 0,
            //  bibList: [],

            showAltimetria: false,
            showPasso: false,
            mainroute: {},
            startTime: 0,
            currentTime: '--:--:--',
            media: '-',
            mediaUltimoKM: '',
            coordinates: [],
            coordTimes: [],
            dataTrack: null,

            paces: {},
            altitude: [],
            passo: [],
            medie: [],
            isMetric: true,

            //listaRil: [],

            initAnimation: false,

            UNITA_MINIMA_SEGMENTO: 10, // divido il percorso in pezzi da 100 metri
            mappaPoints: [],

            initMap: false,

            top10: [],
            staff: [],
            preferiti: [],
            card: ''

        };
    },
    mounted() {
        window.markers = {};
        //   this.trackdataraw = {};
        window.maxFrames = 100;
        window.currentFrame = 0;
        window.map = null;
        window.dataTrack = {};
        window.bibList = this.bibList;
        window.index = 0;

        window.indexRotation = 0;

        // window.deviceMap = this.deviceMap;

        this.setupGpx();

        setTimeout(this.setupMap, 1000);

        var value = document.createElement('pre');
        var timer2;
        var marker;

        window._pause = false;
        window.clearInterval(window.timer2);

        this.$root.$on('command', this.command);
    },

    /*watch: {
        listaRil(newValue) {
            if (newValue) {
                console.log("New")
            }
        },
    },*/

    methods: {
        command({
            command
        }) {
            if (command.id == 'updateTracks') {
                this.updateTracks(command.tracks);
            } else if (command.id == 'updateList') {
                this.listaRil = command.tracks;
                this.renderAtleti()
            } else if (command.id == 'centerTo') {
                this.centerTo(command.place);
            } else if (command.id == 'updateAllMarkers') {
                this.updateAllMarkers(command.participants);
            }
        },
        mapStyle() {
            var styleBase =
                ' height: ' + (window.outerHeight /2) + 'px; width: 100% ';
            // console.log(styleBase);
            return styleBase;
        },

        altimetriaStyle() {
            var styleBase =
                'position: absolute;   top: ' +
                (window.outerHeight - 300) +
                'px;  left: 0px;    width: 1000px;     height: 150px;     z-index: 1001;';
            //console.log(styleBase);
            return styleBase;
        },

        passoStyle() {
            var styleBase =
                'position: absolute;   top: ' +
                '200px;  left: 0px;    width: 300px;     height: 150px;     z-index: 1001;';
            //console.log(styleBase);
            return styleBase;
        },

        confClass(device) {
            var styleBase = 'mt-2 ml-2 mr-2 pa-1 markerConfig ';
            return styleBase;
        },
        confStyle(device) {
            var styleBase = '';
            if (device.color)
                styleBase += '  border-left: 10px solid ' + device.color + '; ';
            return styleBase;
        },

        switchLayer(layer) {
            var layerId = layer.target.id;
            this.styleMap = 'mapbox://styles/mapbox/' + layerId;
            this.setupMap();
        },

        setupMap() {
            var self = this;
            mapboxgl.accessToken = this.accessToken;

            window.map = new mapboxgl.Map({
                container: 'mapContainer',
                //style: "mapbox://styles/mapbox/streets-v11",
                style: this.styleMap,
                center: [14.170517291137543, 37.416212197410076],
                zoom: 6,
            });

            window.map.addControl(new mapboxgl.NavigationControl());
            window.map.setPitch(60);

            var layerList = document.getElementById('menu');
            var inputs = layerList.getElementsByTagName('input');

            for (var i = 0; i < inputs.length; i++) {
                inputs[i].onclick = this.switchLayer;
            }

            window.map.on('zoom', function (e) {
                if (window.map.getZoom() <= 14) self.velocita = 10;
                else {
                    self.velocita = 10 + (window.map.getZoom() - 14) * 100;
                }
            });

            window.map.on('load', function (e) {
                console.log('Map loaded>');

                console.log('Disegna percorso>');
                self.drawPercorso(self.mainroute);

                //console.log('Crea mappa metri>');
                // self.createMainMap();

                console.log('Disegna marcatori km>');
                self.renderDistanceMarkers();

                //console.log('Disegna marcatori atleti>');
                self.renderAtleti();

                //self.loadAltimetria(self.mainroute);
                self.flyTo(self.coordinates[0], 0.5);

                this.initMap = true;
            });
            setTimeout(this.caricaPoi, 12000);
            //

        },

        caricaPoi() {
            this.listaPoi.forEach((poi) => {
                this.loadPOI(poi);
            });
        },

        flyTo(lonLat, speed) {
            console.log('flyTo:' + JSON.stringify(lonLat));

            window.map.flyTo({
                bearing: 90 * Math.random(),
                center: lonLat,
                zoom: 14,
                // pitch: 40 * Math.random(),
                speed: speed,
                curve: 0.5,
            });
        },

        centerTo(p) {
            this.flyTo(p, 0.5);
        },

        pauseBtn() {
            this.pause = true;
            window._pause = this.pause;
        },
        playBtn() {
            this.pause = false;
            window._pause = this.pause;
        },
        pauseToggle() {
            this.pause = !this.pause;
            window._pause = this.pause;
        },
        altimetriaToggle() {
            this.showAltimetria = !this.showAltimetria;
        },
        top10Toggle() {
            if (this.card == 'top10') this.card = '';
            else this.card = 'top10';
        },

        rotateCamera(timestamp) {
            //timestamp = 10000;
            // clamp the rotation between 0 -360 degrees
            // Divide timestamp by 100 to slow rotation to ~10 degrees / sec
            // console.log('Rotazione:' + ((timestamp / 1000) % 360));

            window.map.rotateTo((timestamp / 1000) % 360, {
                duration: 5000,
            });
            // Request the next frame of the animation.
            //requestAnimationFrame(this.rotateCamera);
        },

        setupGpx() {
            var self = this;
            this.mainroute = this.configuration[0];
            this.mappaPoints = this.configuration[0].mappaPoints;
            this.coordinates = this.mainroute.coordinates;

        },

        drawPercorso(route) {
            var idPercorso = route.id;

            window.map.addSource('mainroute' + idPercorso, {
                type: 'geojson',
                data: {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "properties": {},
                        "geometry": {
                            "type": "LineString",
                            "coordinates": route.coordinates
                        }
                    }]
                }
            });

            console.log(route)

            /* window.map.addSource('mainroute' + idPercorso, {
                 type: 'geojson',
                 data: this.trackdataraw['mainroute' + idPercorso],
             });*/
            window.map.addLayer({
                id: 'mainroute' + idPercorso,
                type: 'line',
                source: 'mainroute' + idPercorso,
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round',
                },
                paint: {
                    'line-color': route.color,
                    'line-width': 5,
                },
            });

        },

        //render labels function
        renderDistanceMarkers() {
            //distanceLabel object
            var distanceLabels = {
                type: 'FeatureCollection',
                features: [],
            };

            //added it as a map source
            map.addSource('distanceLabels', {
                type: 'geojson',
                data: distanceLabels,
            });

            //added distancLabels as a map layer
            map.addLayer({
                id: 'distanceLabels',
                type: 'symbol',
                source: 'distanceLabels',
                paint: {
                    'text-color': 'white',
                },
                layout: {
                    'symbol-placement': 'point',
                    'text-font': [
                        'Open Sans Regular',
                        'Arial Unicode MS Regular',
                    ],
                    'text-field': '{unit}{distance}',
                    'text-anchor': 'center',
                    'text-justify': 'center',
                    'text-size': 13,
                    'icon-allow-overlap': false,
                    'icon-ignore-placement': true,
                },
            });

            var unit = this.isMetric == true ? 'kilometers' : 'miles';
            var unitShort = this.isMetric == true ? 'km' : 'mi';

            //rounding down kilometers (11.76km -> 11km)
            const routeDistance = this.mainroute['puntoMax'];
            let points = [];

            //only draw labels if route is longer than 1km
            if (routeDistance !== 0) {
                // Draw an arc between the `origin` & `destination` of the two points

                for (let i = 0; i < routeDistance; i = i + 1000) {
                    const indexP = '' + i;
                    const latLon = this.mainroute.mappaPoints[indexP].split(",");

                    points.push({
                        type: 'Feature',
                        properties: {
                            unit: unitShort,
                            name: 'Pippo',
                            distance: i / 1000
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: [parseFloat(latLon[0]), parseFloat(latLon[1])]
                        },
                    });
                }

                distanceLabels.features = points;

                //update distances for the label texts
                //for (var i = 0; i < points.length; i++) {
                //    distanceLabels.features[i].properties.distance = i + 1; //First one would be 0
                //}

                //render now labels
                map.getSource('distanceLabels').setData(distanceLabels);
            } else {
                console.log("Errore")
            }
        },

        createMarker(_liveTrack) {
            var button = document.createElement('div');
            button.className = 'marker' + _liveTrack.icon;
            button.id = "P_" + _liveTrack.deviceid;
            button.innerHTML = _liveTrack.nomeShort;

            if (_liveTrack.tipo !== 'ATLETA') {
                button.innerHTML = _liveTrack.cognome;
            }

            /*  button.addEventListener('click', function (_event) {
                console.log(_event.target.id);
                this.$emit('clickMarker', { id: _event.target.id });
            });*/

            //console.log(JSON.stringify(lonLat));
            window.markers['P_' + _liveTrack.deviceid] = new mapboxgl.Marker(
                    button
                )
                .setLngLat(_liveTrack.lonLat)
                .setPopup(new mapboxgl.Popup().setHTML(_liveTrack.descrizione))
                .addTo(window.map);
        },

        updateMarker(p) {
            const _marker = window.markers['P_' + p.deviceid];
            if (p.showMarker) {
                if (_marker == undefined && p.lonLat !== undefined) {
                    this.createMarker(p);
                }
            } else {
                if (_marker !== undefined) {
                    window.markers['P_' + p.deviceid] = undefined;
                    _marker.remove();
                }
            }
        },

        updateAllMarkers(participants) {
            participants.forEach((p) => {
                this.updateMarker(p);
            });
        },

        renderAtleti() {
            this.initAnimation = true;
            this.animateMarkers(10000);
        },

        animateMarkers(timestamp) {
            let self = this;
            //console.log(timestamp)

            this.listaRil.forEach((_liveTrack) => {
                if (_liveTrack.posIndex == undefined) _liveTrack.posIndex = 0;
                const app = this.mainroute.mappaPoints["" + _liveTrack.posIndex];
                if (app !== undefined) {

                    let coords = app.split(",");
                    let lonLat = {
                        lon: parseFloat(coords[0]),
                        lat: parseFloat(coords[1]),
                    };

                    if (_liveTrack.speed == undefined) _liveTrack.speed = 0.1;
                    if (_liveTrack.metri == undefined) _liveTrack.metri = 1;

                    _liveTrack.lonLat = lonLat;
                    _liveTrack.metri = parseFloat(_liveTrack.metri) + parseFloat(_liveTrack.speed) / 5;
                    _liveTrack.posIndex = Math.floor(_liveTrack.metri / 10) * 10;

                    _liveTrack.passo = "" + this.round(_liveTrack.speed * 0.06, 2) + " " + self.mainroute.passo
                    if (self.mainroute.passo == 'km/h') {
                        _liveTrack.passo = this.round(_liveTrack.speed * 3.6, 1) + " " + self.mainroute.passo
                    }

                    //console.log('posIndex dev:' + _liveTrack.deviceid + " = " + _liveTrack.posIndex + " metri: " + _liveTrack.metri) ;
                }

            });

            this.top10 = this.listaRil.sort((a, b) => b.metri - a.metri).filter(a => a.tipo == 'ATLETA').slice(0, 10);
            this.staff = this.listaRil.sort((a, b) => b.metri - a.metri).filter(a => a.tipo == 'STAFF');

            this.updateTracks();

            /* window.setTimeout(function () {
                 requestAnimationFrame(self.animateMarkers);
             }, this.velocita);*/

            window.setTimeout(self.animateMarkers, 200);
        },

        updateTracks() {
            this.listaRil.forEach((_liveTrack) => {
                if (_liveTrack.lonLat == undefined) {
                    _liveTrack.lonLat = this.mainroute.mappaPoints["0"].split(",");
                }
                //console.log('Caricamento Marker ' + JSON.stringify(_liveTrack));
                if (_liveTrack.lonLat !== undefined && _liveTrack.showMarker) {
                    const _marker = window.markers['P_' + _liveTrack.deviceid];
                    if (_marker == undefined) {
                        this.createMarker(_liveTrack);
                    } else {
                        _marker.setLngLat(_liveTrack.lonLat);
                        //console.log("Check marker")
                        // var button = document.getElementById("P_"+_liveTrack.deviceid);
                        /* if (button != undefined) {
                             if ( _liveTrack.status == 'OFFLINE') {
                                 button.className = 'markerPARTICIPANT_OFFLINE';
                             } else if ( _liveTrack.status == 'ONLINE') {
                                 button.className = 'markerPARTICIPANT';
                             }
                         }*/
                    }
                }
            });

            //this.listaRil = lista;

            // }

            //this.rotateCamera(new Date());

            if (!this.initAnimation) {
                this.initAnimation = true;
                //this.flyTo(this.mappaPoints[0].geometry.coordinates, 0.5);

                this.animateMarkers(10000);
            }
        },

        round(value, precision) {
            var multiplier = Math.pow(10, precision || 0);
            return Math.round(value * multiplier) / multiplier;
        },

        roundKm(number) {
            let r = "" + this.round(number / 1000, 1)
            if (r.indexOf(".") == -1) r = r + ".0";
            return r;
        },

        loadPOI(poi) {
            console.log('Caricamento POI sulla mappa');
            if (poi.coordinates == undefined || poi.coordinates.trim() == '')
                return;

            var button = document.createElement('div');
            button.className = 'markerPOI';
            button.id = poi.id;
            button.innerHTML = poi.nome;

            button.className = 'marker' + poi.type;

            /*  button.addEventListener('click', function (_event) {
                console.log(_event.target.id);
                this.$emit('clickMarker', { id: _event.target.id });
            });*/
            let coords = poi.coordinates
                .replace(/[\s]+[,]+|[,]+[\s]+/g, ',')
                .trim()
                .split(',');
            let lonLat = {
                lon: parseFloat(coords[1]),
                lat: parseFloat(coords[0]),
            };
            //console.log(JSON.stringify(lonLat));
            window.markers[poi.id] = new mapboxgl.Marker(button)
                .setLngLat(lonLat)
                .setPopup(new mapboxgl.Popup().setHTML(poi.descrizione))
                .addTo(window.map);
        },

        loadAltimetria() {
            var dataAlt = [];
            var index = 0;
            this.coordinates.forEach((coord) => {
                if (coord.length > 2) {
                    dataAlt.push({
                        meters: coord[2],
                        index: index++
                    });
                } else {
                    dataAlt.push({
                        meters: 0,
                        index: index++
                    });
                }
            });

            return dataAlt;
        },

        getAltitude() {
            return this.altitude;
        },

        getPartecipante(partecipante) {
            // "#"+ partecipante.pett + " - " +
            return partecipante.cognome + " " + partecipante.nome.substring(0, 1) + ".";
        },

        getStaff(partecipante) {
            // "#"+ partecipante.pett + " - " +
            return partecipante.cognome + " " + partecipante.nome;
        }

    },
};
</script>

<style scoped>
.basemap {
    width: 100%;
    height: 100%;
}
</style>

<style>
.marker {
    background-color: white;
    color: red;
    border: 1px solid black;
    width: 40px;
    height: 20px;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
}

.markerKM {
    background-color: lightgray;
    color: black;
    width: 15px;
    height: 20px;
    border-radius: 10px;
    font-size: 8px;
    /*cursor: pointer;
    border: 1px solid black;*/
    text-align: center;
}

.markerPuntoGuida {
    background-color: yellow;
    color: white;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    /*cursor: pointer;
    border: 1px solid black;*/
    text-align: center;
}

.markerBanner {
    background-color: yellow;
    color: white;
    width: 12px;
    height: 12px;
    border-radius: 5px;
    border: 1px solid red;
    /*cursor: pointer;
    ;*/
    text-align: center;
}

.markerPOI {
    background-color: yellowgreen;
    color: white;
    _border: 1px solid black;
    width: 70px;
    height: 20px;
    border-radius: 10px;
    cursor: pointer;
    text-align: center;
}

.markerPARTENZA {
    background-color: yellowgreen;
    color: white;
    _border: 1px solid black;
    width: 70px;
    height: 20px;
    border-radius: 10px;
    cursor: pointer;
    text-align: center;
}

.markerARRIVO {
    background-color: blue;
    color: white;
    _border: 1px solid black;
    width: 70px;
    height: 20px;
    border-radius: 10px;
    cursor: pointer;
    text-align: center;
}

.markerRISTORO {
    background-color: cyan;
    color: white;
    _border: 1px solid black;
    width: 70px;
    height: 20px;
    border-radius: 10px;
    cursor: pointer;
    text-align: center;
}

.markerA {
    background-color: orange;
    color: black;
    width: 35px;
    height: 20px;
    border-radius: 10px;
    font-size: 8px;
    /*cursor: pointer;*/
    border: 1px solid grey;
    text-align: center;
}

.markerMED {
    background-color: white;
    color: red;
    width: 35px;
    height: 20px;
    border-radius: 5px;
    font-size: 8px;
    /*cursor: pointer;*/
    border: 1px solid grey;
    text-align: center;
}

.markerMOTO {
    background-color: black;
    color: yellow;
    width: 35px;
    height: 20px;
    border-radius: 5px;
    font-size: 8px;
    /*cursor: pointer;*/
    border: 1px solid grey;
    text-align: center;
}

.markerIG {
    background-color: green;
    color: white;
    width: 35px;
    height: 20px;
    border-radius: 5px;
    font-size: 8px;
    /*cursor: pointer;*/
    border: 1px solid grey;
    text-align: center;
}

.markerGIUD {
    background-color: red;
    color: white;
    width: 35px;
    height: 20px;
    border-radius: 5px;
    font-size: 8px;
    /*cursor: pointer;*/
    border: 1px solid white;
    text-align: center;
}

.markerFG {
    background-color: grey;
    color: white;
    width: 35px;
    height: 20px;
    border-radius: 5px;
    font-size: 8px;
    /*cursor: pointer;*/
    border: 1px solid white;
    text-align: center;
}

.markerPARTICIPANT_OFFLINE {
    background-color: grey;
    color: black;
    width: 30px;
    height: 20px;
    border-radius: 10px;
    font-size: 8px;
    /*cursor: pointer;
    border: 1px solid black;*/
    text-align: center;
}

.markerHidden {
    background-color: grey !important;
    color: lightgray;
}

#info {
    display: block;
    position: relative;
    margin: 0px auto;
    width: 50%;
    padding: 10px;
    border: none;
    border-radius: 3px;
    font-size: 12px;
    text-align: center;
    color: #222;
    background: #fff;
}

.top10-container {
    position: absolute;
    top: 25px;
    left: 0px;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    font-size: 11px;
    line-height: 18px;
    display: block;
    margin: 0;
    padding: 5px 10px;
    border-radius: 8px;
}

.staff-container {
    position: absolute;
    top: 25px;
    left: 0px;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    font-size: 11px;
    line-height: 18px;
    display: block;
    margin: 0;
    padding: 5px 10px;
    border-radius: 8px;

}

.menu-container {
    position: absolute;
    top: 30px;
    left: 0px;
    z-index: 1;
    font-size: 11px;
    line-height: 18px;
    display: block;
    
    writing-mode: vertical-lr;

}

.tab-menu {
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    font-size: 12px;
    border: 1px solid grey;
    border-radius: 0px 10px 10px 0px;
    width: 300px;
    padding: 10px;
    margin: 1px
}


#menu {
    background: #fff;
    padding-left: 10px;
    font-family: 'Open Sans', sans-serif;
}

#menu>* {
    padding-right: 20px;
    font-family: 'Open Sans', sans-serif;
}

.timer {
    background-color: orange;
    color: black;
    border-radius: 0px;
}

.passo {
    _background-color: orange;
    __color: black;
    padding-left: 10px;
    border-radius: 3px;
    padding-right: 10px;
    border: 1px solid gray;
    width: 80px;
    text-align: end;
}
</style>
